import React, { useState } from 'react';
import styles from '../PrimaryMainTable.module.scss';

import {
  FormControlLabel,
  Grid,
  Menu,
  MenuItem,
  Radio,
  RadioGroup,
  Typography,
} from '@material-ui/core';
import SelectInput from 'app/components/Form/Inputs/SelectInput';
import { _t } from 'app/utils/i18n';
import {
  getFromLocalStorage,
  constants,
  setInLocalStorage,
} from 'app/utils/localStorage';
import PopperQuestionMark from 'app/components/PopperQuestionMark';
import { DotsIcon } from 'app/assets/images/icons';
interface TableControlsProps {
  title: string;
  currentDataSource: any;
  limit: any;
  tableMode: string;
  setTableOpts: (value: any) => void;
  setIsEditModeOn: (status: boolean) => void;
  setColumns: any;
  getColumns: (val: any) => void;
  showedColumns: any;
  columns: any;
  setLimit: any;
  loadData: any;
  sortInfo: any;
  filters: any;
  compId?: string;
  currentPage: number;
  isLivePaginationOn: boolean;
  baseTableName: string;
}

const TableControls = ({
  title,
  currentDataSource,
  tableMode,
  limit,
  setTableOpts,
  setIsEditModeOn,
  setColumns,
  getColumns,
  showedColumns,
  columns,
  setLimit,
  loadData,
  sortInfo,
  filters,
  compId,
  currentPage,
  isLivePaginationOn,
  baseTableName,
}: TableControlsProps): any => {
  const currentLanguage = getFromLocalStorage(constants.language);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event: any) => {
    setAnchorEl(event?.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: any) => {
    setTableOpts(event.target.value);
    setInLocalStorage(`${baseTableName}_table_mode`, event.target.value);
    handleClose();
    if (event.target.value === 'view') {
      loadData({
        ...sortInfo,
        ...filters,
        backToViewMode: true,
      });
    }
  };
  const { records, total_record } = currentDataSource
    ? currentDataSource
    : { records: [], total_record: 0 };
  const currentRecordsTotal = isLivePaginationOn
    ? limit * currentPage > total_record
      ? total_record
      : limit * currentPage
    : records?.length * currentPage > total_record
    ? total_record
    : records?.length * currentPage;

  return (
    !title && (
      <Grid
        item
        // sm={5}
        className={styles.PrimaryTable__BulkActionsPartTwo}
        id={compId}
        data-testid="table-control-holder"
      >
        <Typography variant="subtitle1">
          {currentRecordsTotal || 0} {_t('basic:items_of')}{' '}
          {currentDataSource?.total_record || 0}
        </Typography>
        <PopperQuestionMark compId={compId} />
        <>
          <div>
            <div>
              <span
                onClick={handleClick}
                id="maintTable-menuIcon"
                style={{
                  marginInlineStart: '10px',
                  cursor: 'pointer',
                  minWidth: '15px',
                  minHeight: '20px',
                  display: 'block',
                }}
                data-testid="table-control-dots"
              >
                <DotsIcon />
              </span>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{ className: styles.PopperMenu }}
                elevation={0}
                transformOrigin={
                  currentLanguage == 'en'
                    ? { vertical: 'top', horizontal: 'right' }
                    : { vertical: 'top', horizontal: 'left' }
                }
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              >
                <Typography className={styles.PopperMenu__DropdownHeader}>
                  {_t('basic:table_view')}
                </Typography>
                <MenuItem
                  key={'edit table'}
                  onClick={() => {
                    setIsEditModeOn(true);
                    setColumns(
                      getColumns({
                        draggable: true,
                        isEdit: true,
                        currentColumnsState: showedColumns,
                        columns,
                      })
                    );
                    handleClose();
                  }}
                  classes={{ root: styles.PopperMenu__EditTable }}
                  data-testid="table-control-menu"
                >
                  {_t('basic:edit_table_columns')}
                </MenuItem>
                <Typography className={styles.PopperMenu__DropdownHeaderTwo}>
                  {_t('basic:item_view')}
                </Typography>
                <Typography
                  component="div"
                  className={styles.PopperMenu__RadioGroupStyle}
                >
                  <RadioGroup
                    name="item_view"
                    value={tableMode}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="auto"
                      control={<Radio size="small" />}
                      label={_t('basic:auto_scroll')}
                      id="auto-scroll"
                      data-testid="auto-scroll-holder"
                    />
                    <FormControlLabel
                      value="view"
                      control={<Radio size="small" />}
                      label={_t('basic:item_view')}
                      id="item-view"
                      data-testid="item-view-holder"
                    />
                  </RadioGroup>
                  <Typography
                    component="div"
                    className={styles.PopperMenu__ItemViewSelect}
                    id="view-item-menu"
                  >
                    {tableMode === 'view' ? (
                      <SelectInput
                        position="top"
                        placeholder=""
                        value={{ label: limit, value: limit }}
                        onChange={(e) => {
                          setLimit(+e.value);
                          setInLocalStorage(`${baseTableName}_limit`, +e.value);
                          loadData({
                            ...sortInfo,
                            ...filters,
                            limit: +e.value,
                            page: 1,
                          });
                          handleClose();
                        }}
                        options={[
                          { label: '10', value: '10' },
                          { label: '20', value: '20' },
                          { label: '40', value: '40' },
                          { label: '60', value: '60' },
                          { label: '80', value: '80' },
                          { label: '100', value: '100' },
                        ]}
                        name={''}
                      />
                    ) : null}
                  </Typography>
                </Typography>
              </Menu>
            </div>
          </div>
        </>
      </Grid>
    )
  );
};

export default TableControls;
